// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resources {
  box-sizing: border-box;
  display: block;
  padding: 64px 16px 8px;
  margin: 1em 0;
  background: #F3F1EB;
  border-radius: 6px;
	position: relative;
	font-family: sans-serif;
	color: #262B33;
}

.resources:before {
  content: "Resources";
  display: block;
  font-weight: 600;
  font-size: 12px;
  line-height: 16px;
  color: #776D59;
  position: absolute;
  top: 20px;
  left: 16px;
  right: 16px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(119,109,89,0.15);
}
`, "",{"version":3,"sources":["webpack://./src/plugins/resources/styles.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,cAAc;EACd,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;CACnB,kBAAkB;CAClB,uBAAuB;CACvB,cAAc;AACf;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,8CAA8C;AAChD","sourcesContent":[".resources {\n  box-sizing: border-box;\n  display: block;\n  padding: 64px 16px 8px;\n  margin: 1em 0;\n  background: #F3F1EB;\n  border-radius: 6px;\n\tposition: relative;\n\tfont-family: sans-serif;\n\tcolor: #262B33;\n}\n\n.resources:before {\n  content: \"Resources\";\n  display: block;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 16px;\n  color: #776D59;\n  position: absolute;\n  top: 20px;\n  left: 16px;\n  right: 16px;\n  padding-bottom: 20px;\n  border-bottom: 1px solid rgba(119,109,89,0.15);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
